const createEventsState = (set) => ({
  allEvents: null,
  setAllEvents: (fetchedEvents) => set({ allEvents: { ...fetchedEvents } }),
});

export { createEventsState };
